import { useState, useEffect, useCallback, useRef } from 'react';
import { Customer } from '../types/exporter';
import axiosInstance from '../../../../api/axiosInstance';

interface UseCustomersReturn {
  customers: Customer[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useCustomers = (): UseCustomersReturn => {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const mountedRef = useRef(true);

  const fetchCustomers = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const payload = { Id: 0, SearchKeyword: '', Page: 1, Take: 2147483647 };
      const { data } = await axiosInstance.get(
        `/api/cantrackv3/ReadCustomers?payload=${JSON.stringify(payload)}`,
      );
      const results = data?.Data || [];
      if (mountedRef.current) {
        setCustomers(results.map((c: { Id: number; Name: string }) => ({ cust_id: c.Id, cust_name: c.Name })));
      }
    } catch (err) {
      if (mountedRef.current) {
        const errorMessage = err instanceof Error ? err.message : 'Failed to fetch customers';
        setError(errorMessage);
        console.error('Failed to fetch customers:', err);
      }
    } finally {
      if (mountedRef.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    mountedRef.current = true;
    fetchCustomers();
    return () => { mountedRef.current = false; };
  }, [fetchCustomers]);

  return { customers, loading, error, refetch: fetchCustomers };
};
